import { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { name: "", email: "", phone: "", address: "" };

export const QuickAddCustomerDialog = ({ open, onOpenChange, initialName = "", onCreated, testId = "customer-select" }) => {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setForm({ ...EMPTY, name: initialName });
  }, [open, initialName]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSaving(true);
    try {
      const { data } = await axios.post(`${API}/customers`, form);
      toast.success(`Customer "${data.name}" added and selected`);
      onOpenChange(false);
      onCreated(data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to add customer");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[460px]" data-testid={`${testId}-quick-add-dialog`}>
        <DialogHeader>
          <DialogTitle>Add New Customer</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3 mt-2">
          <div>
            <Label htmlFor="qa-name">Name *</Label>
            <Input id="qa-name" value={form.name} onChange={set("name")} required autoFocus data-testid={`${testId}-quick-add-name`} />
          </div>
          <div>
            <Label htmlFor="qa-email">Email *</Label>
            <Input id="qa-email" type="email" value={form.email} onChange={set("email")} required data-testid={`${testId}-quick-add-email`} />
          </div>
          <div>
            <Label htmlFor="qa-phone">Phone *</Label>
            <Input id="qa-phone" value={form.phone} onChange={set("phone")} required data-testid={`${testId}-quick-add-phone`} />
          </div>
          <div>
            <Label htmlFor="qa-address">Address *</Label>
            <Input id="qa-address" value={form.address} onChange={set("address")} required data-testid={`${testId}-quick-add-address`} />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid={`${testId}-quick-add-cancel`}>Cancel</Button>
            <Button type="submit" disabled={saving} className="bg-indigo-600 hover:bg-indigo-700" data-testid={`${testId}-quick-add-submit`}>{saving ? "Adding…" : "Add & Select"}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
